<div
	class="field"
	[ngStyle]="availability.styles"
	[ngClass]="{
		posState: ['S', 'L', 'R'].includes(availability.state),
		reservation: availability.state === 'R',
	}"
	matTooltip="{{ availability?.comment }}"
	(click)="openDetails()"
>
	<i class="fas fa-bezier-curve" *ngIf="availability.extendedStay === 1"></i>
	<i class="fas fa-anchor" *ngIf="availability.roomGuarantee === 1"></i>
	<i class="far fa-eye" *ngIf="availability.viewGuarantee === 1"></i>
	<i class="fa-solid fa-car" *ngIf="availability.ownTransport === 1"></i>
	<i class="fa-solid fa-plane" *ngIf="availability.transportPlane === 1"></i>
	{{ availability?.stateLabel }}
</div>
